import { render, staticRenderFns } from "./FormServices.vue?vue&type=template&id=4a24c9ed&scoped=true&"
import script from "./FormServices.vue?vue&type=script&lang=js&"
export * from "./FormServices.vue?vue&type=script&lang=js&"
import style0 from "./FormServices.vue?vue&type=style&index=0&id=4a24c9ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24c9ed",
  null
  
)

export default component.exports